
  import {Component, Vue} from 'vue-property-decorator';
  import CookieDlg from "@/components/CookieDlg.vue";
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import TabSwitcher from "@/components/TabSwitcher";
  import Cookies from "js-cookie";
  import {installAds} from "@/components/AdSense";
  import $ from "jquery";
  import {gaSendPageview} from "@/components/Analytics";

  @Component({
    components: {CookieDlg, LandingSection, Header}
  })
  export default class AboutLanding extends Vue {
    private adsSidebar = '';
    private readonly needsCookieConsent = Cookies.get("CookieConsent") !== "true";
    private tabSwitcher = new TabSwitcher();

    public $refs!: {
      cookieDlg: CookieDlg;
    };

    public mounted() {
      this.adsSidebar = document.getElementById('ads-sidebar').innerHTML;
      this.tabSwitcher.init('history');
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      installAds($(this.$el).find(".adsbygoogle"));
      gaSendPageview();
    }
  }
